/************************************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.8.20
Tree Inventory Transaction Table: For transactions only
************************************************************************/
import React from 'react';
import moment from 'moment';
import CultivationModal from '../cult_modal';
import TreeInventoryEditForm from './tree_inventory_edit_form';
import TreeInventoryDisplay from './tree_inventory_display';
import { packageForm } from '../../cult_utils';

const TreeInventoryTransactionTable = ({ inventory, _inventory, user, fields, approvers, formType, readOnly, formId, setFormType, 
  setInventoryToEdit, editInventoryRequest, deleteInventoryRequest, setInventoryToDelete, fetchFields, onClick }) => {
  if (readOnly) {
    return (
      <table className="bordered centered responsive-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Location</th>
            <th>Field</th>
            <th>Quantity</th>
            <th>Transaction</th>
            <th>Approved</th>
            <th>Approved Date</th>
            <th>Comments</th>
          </tr>
        </thead>
        <tbody>
          {
            inventory.map((i) => (
              <tr key={i.id}>
                <td>{ moment(i.date).format('YYYY-MM-DD') }</td>
                <td>{ i.location === 71 ? "71 - Ka'u" : "72 - Kea'au" }</td>
                <td>{ i.field }</td>
                <td>{ i.quantity }</td>
                <td>{ i.issuedOrReceived === 'I' ? 'Issued' : 'Received' }</td>
                <td>{ i.isApproved === 0 ? <span className="red-text">Awaiting Approval</span> : <span className="green-text">Approved</span> }</td>
                <td>{ i.approvedDate ? <b>{moment(i.approvedDate).format('MM/DD/YYYY')}</b> : 'N/A' }</td>
                <td>{ i.comments }</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    )
  }
  return (
    <table className="highlight bordered centered responsive-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Location</th>
          <th>Field</th>
          <th>Quantity</th>
          <th>Issued or Received</th>
          <th>Approved</th>
          <th>Approved Date</th>
          <th>Approve</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {
          inventory.map((i) => (
            <tr key={i.id}>
              <td>{ moment(i.date).format('YYYY-MM-DD') }</td>
              <td>{ i.location === 71 ? "71 - Ka'u" : "72 - Kea'au" }</td>
              <td>{ i.field }</td>
              <td>{ i.quantity }</td>
              <td>{ i.issuedOrReceived === 'I' ? 'Issued' : 'Received' }</td>
              <td>{ i.isApproved === 0 ? <span className="red-text">Awaiting Approval</span> : <span className="green-text">Approved</span> }</td>
              <td>{ i.approvedDate ? <b>{moment(i.approvedDate).format('MM/DD/YYYY')}</b> : 'N/A' }</td>
              <td>
                { i.isApproved ? ''
                  : i.approver === user.eid ?
                    <button className="btn white-text green waves-effect" onClick={() => onClick({ user, inventoryTransaction: i })}>Approve</button>
                    : <button className="btn white-text green" disabled>Approve</button>
                }
              </td>
              <td>
                  {
                    i.isApproved ?
                      <ul className="btn-actions">
                        <li className="action-btn-li">
                          <a className="btn-floating green pointer modal-trigger tooltipped btn-squared" href={`#${i.id}-view`}
                            onClick={() => console.log(i)}  data-position="left" data-tooltip="View">
                            <i className="material-icons">info</i>
                          </a>
                        </li>
                      </ul>
                      : i.submitter === user.eid ?
                        <ul className="btn-actions">
                          <li className="action-btn-li">
                            <a className="btn-floating blue pointer modal-trigger tooltipped btn-squared" href={`#${i.id}-edit`}
                              onClick={() => setInventoryToEdit({ inventory: i, formId: `edit-form-${i.id}`})}  data-position="left" data-tooltip="Edit">
                              <i className="material-icons">mode_edit</i>
                            </a>
                          </li>
                          <li className="action-btn-li">
                            <a className={`btn-floating red pointer modal-trigger tooltipped btn-squared`} href={`#${i.id}-delete`}
                              onClick={() => setInventoryToDelete(i)} data-position="top" data-tooltip="Delete">
                              <i className="material-icons">clear</i>
                            </a>
                          </li>
                        </ul>
                      : <div></div>
                  }
                  {
                    i.isApproved ?
                    <div>
                      {
                      CultivationModal(TreeInventoryDisplay)
                      // eslint-disable-next-line
                      ({
                        id: `${i.id}-view`,
                        approvers,
                        data: i,
                        footer: true,
                        toView: true,
                        createOrEdit: false,
                        previousInventoryTransactions: [],
                        approver: {},
                        view: true,
                        onClick: () => console.log(i)
                      })
                    }
                    </div>
                    : 
                    <div>
                    {
                      CultivationModal(TreeInventoryEditForm)
                      // eslint-disable-next-line
                      ({
                        id: `${i.id}-edit`,
                        approvers,
                        inventory: i,
                        fields: fields,
                        footer: true,
                        formType,
                        formId: `edit-form-${i.id}`,
                        createOrEdit: true,
                        view: false,
                        onClick: () => editInventoryRequest({ 
                          data: packageForm(`edit-form-${i.id}`), 
                          formId: `edit-form-${i.id}`, 
                          inventory: _inventory,
                          oldInventoryRecord: i,
                          user 
                        }),
                        setFormType,
                        fetchFields
                      })
                    }
                    {
                      CultivationModal(TreeInventoryDisplay)
                      // eslint-disable-next-line
                      ({
                        id: `${i.id}-delete`,
                        approvers,
                        data: i,
                        footer: true,
                        formType,
                        formId: `edit-form-${i.id}`,
                        createOrEdit: true,
                        toDelete: true,
                        previousInventoryTransactions: [],
                        approver: {},
                        view: false,
                        onClick: () => deleteInventoryRequest(i)
                      })
                    }
                    </div>
                  }
              </td>
            </tr>
          ))
        }
      </tbody>
    </table>
  )
}

export default TreeInventoryTransactionTable;





























/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_inventory_transaction_table.js